import { useCan } from "../auth/use-can";
import { useModules } from "../shell/modules-context";

/**
 * **Whether a price per use may be shown** (QF-D20, narrowing MS-D11): the
 * clinic has Accounting **and** this person holds `accounting.view`. It is a
 * cost figure, so it follows the rule tray cost and profit already follow
 * (QF-D1). Pack prices stay visible to whoever buys stock.
 */
export function useSeesPerUseCost(): boolean {
  const { has } = useModules();
  const can = useCan();
  return has("ACCOUNTING") && can("accounting.view");
}
